<template>
    <div>
        <el-row class="bindAreaBtn" >
            <el-button icon="el-icon-edit" @click="dialogFormVisible = true">绑定区域 至 {{branchInfo.name}}</el-button>
        </el-row>

        <el-table
                :loading="loading"
                :data="branchDistricts"
                border
                style="width: 100%">
            <el-table-column prop="full_name" label="所属省市" width="180"></el-table-column>
            <el-table-column prop="address" label="已绑定业务区域">
                    <template slot-scope="scope" >
                        <el-tag class="areaTag" v-for="district in scope.row.districts" :key="district.district_id" closable @close="unbindDistrict(district.district_id, branchInfo.id)">
                            {{district.district_name}}
                        </el-tag>
                    </template>
            </el-table-column>
        </el-table>

        <el-dialog title="为选择绑定区域"
            center
            :visible.sync="dialogFormVisible"
            width="70%"
            :append-to-body="dialogAppendToBody"
            :before-close="beforeCloseDialog"
            top="10vh">
            <el-form label-width="100px" >
                <el-form-item label="选择省份：" >
                    <el-radio-group class="areaSelect" v-if="provinces.length > 0" v-model="bindForm.province_id">
                        <el-radio-button v-for="province in provinces" :key="province.id" :label="province.id">
                            {{province.name}}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择城市：" >
                        <el-radio-group class="areaSelect" v-if="cities.length > 0" v-model="bindForm.city_id" size="small">
                            <el-radio-button v-for="city in cities" :key="city.id" :label="city.id">{{city.name}}</el-radio-button>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="选择地区：" >
                        <el-transfer v-if="districts.length > 0"
                        filterable
                        :filter-method="filterMethod"
                        filter-placeholder="请输入地区名称"
                        v-model="bindForm.districts"
                        :data="formatDistricts()"
                        :titles="['未选择地区', '已选择地区']" class="districtSelect"
                    >
                    </el-transfer>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="beforeCloseDialog">取 消</el-button>
                <el-button :loading="submiting" type="primary" @click="saveBindArea">保 存</el-button>
            </div>

        </el-dialog>

    </div>


</template>

<script>
    import DistrictService from "~/services/district";
    import {BranchService} from "~/services/Branch";

    export default {
        name: "BindArea",
        props: {
            branchInfo: {
                type: Object,
                required: false,
                value: function () {
                    return null;
                }
            }
        },
        data() {
            return {
                loading: false, // 列表加载状态
                branchDistricts: [], // 部门已绑定的业务地区
                provinces: [],
                cities: [],
                districts: [],
                dialogFormVisible: false,
                dialogAppendToBody: true,
                submiting: false,
                bindForm: {
                    branch_id: 0,
                    province_id: 0,
                    city_id: 0,
                    districts: []
                },
            };
        },
        created: function () {
            this.getProvinces();
            if (this.branchInfo && parseInt(this.branchInfo.id) > 0) {
                this.bindForm.branch_id = this.branchInfo.id;
                this.getBranchDistricts(this.branchInfo.id);
            }
        },
        watch: {

            branchInfo: function (value, oldValue) {
                if (value && parseInt(value.id) > 0) {
                    //alert(value.id);
                    this.branchDistricts = [];
                    this.bindForm.branch_id = value.id;
                    this.getBranchDistricts(value.id);
                }
            },

            'bindForm.province_id': function (value, oldValue) {
                this.cities = [];
                this.districts = [];
                if (parseInt(value) > 0) {
                    this.getCitesByProvinceId(value);
                    this.bindForm.districts = [];
                }
            },

            'bindForm.city_id': function (value, oldValue) {
                this.districts = [];
                if (parseInt(value) > 0) {
                    this.getDistrictsByCityId(value);
                    this.bindForm.districts = [];
                }
            }
        },
        methods: {

            getBranchDistricts(branchId) {
                this.loading = true;
                BranchService.getBranchDistricts(branchId).then(res => {
                    this.loading = false;
                    if (res && res.code == 0) {
                        this.branchDistricts = res.data;
                    }
                });
            },

            /**
             * 得到省份列表
             */
            getProvinces() {
                DistrictService.getProvinces().then(res => {
                    if (res && res.code == 0) {
                        this.provinces = res.data;
                    }
                })
            },

            /**
             * 得到指定省份下的城市
             * @param provinceId
             */
            getCitesByProvinceId(provinceId) {
                DistrictService.getCities(provinceId).then(res => {
                    if (res && res.code == 0) {
                        this.cities = res.data;
                    }
                });
            },

            /**
             * 得到指定城市下的地区
             * @param cityId
             */
            getDistrictsByCityId(cityId) {
                BranchService.getDistricts(cityId).then(res => {
                    if (res && res.code == 0) {
                        this.districts = res.data;
                    }
                })
            },

            /**
             * 格式化地区数据
             * @returns {Array}
             */
            formatDistricts() {
                const data = [];
                this.districts.forEach((dist, index) => {
                    data.push({
                        label: dist.name,
                        key: dist.id,
                        disabled: dist.disabled
                    });
                })
                return data;
            },

            /**
             * 监听弹出窗口关闭前触发事件
             */
            beforeCloseDialog() {
                this.closeDialog();
                // this.$confirm("陛下你还没有保存内容，确认要关闭窗口？").then(_ => {
                //     this.closeDialog();
                // }).catch(_ => {
                //     return;
                // });
            },

            closeDialog() {
                // 清空表单
                this.bindForm.province_id = 0;
                this.bindForm.city_id = 0;
                this.bindForm.districts = [];

                this.dialogFormVisible = false;
            },

            // 搜索过滤地区
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },

            saveBindArea() {
                this.submiting = true;
                BranchService.bindDistrict(this.bindForm).then(res => {
                    if (res && res.code == 0) {
                        this.closeDialog();
                        this.getBranchDistricts(this.branchInfo.id);
                    }
                    this.submiting = false;
                }).catch(err => {
                    console.error(err)
                })
            },

            unbindDistrict(districtId, branchId) {
                this.$confirm("确认要解绑该地区？").then(_ => {
                    BranchService.unbindDistrict(branchId, [districtId]).then(res => {
                        if (res && res.code == 0) {
                            this.getBranchDistricts(branchId);
                        }
                    })
                }).catch(_ => {
                    return;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/branch/BindArea.vue